<template>
    <div>
        <header-nav :cur="7" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span class="infor">合作</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">为您解答</div>
                        <div class="newbot">汇集知识碎片，解决学习难题</div>
                    </div>
                    <div class="input">
                        <input placeholder="请输入您想要寻找的课程" type="text" />
                        <div class="select">搜索</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="navtab">
            <div class="relation">
                <p>留下您的需求及信息，我们会及时联系您</p>
                <div class="know">
                    <span>*学校简介：</span>
                    <div>
                        1、兰州文理学院是甘肃省省属公办全日制普通本科高等学校，是甘肃省培养文化、传媒类人才的主体性高校，也是教育部学校规划建设发展中心“高等学校产教融合创新实验项目”全国5所项目院校之一。
                    </div>
                </div>
                <div class="know">
                    <span>*合作范围：</span>
                    <div>
                        1、建筑类培训。
                    </div>
                </div> 
                <div class="message">
                    <div class="name">您的姓名：</div>
                    <input type="text" class="input" v-model="userName"/>
                    <div class="name">您的需求：</div>
                    <input type="text" class="input1" v-model="content"/>
                    <div class="name">您的联系方式：</div>
                    <input type="text" class="input" v-model="mobile"/>
                    <div class="submit" @click="commitData()">提交申请</div>
                </div>
            </div>
        </div>

        <footer-nav />
    </div>
</template>
<script>
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
export default {
    components: {
        headerNav,
        footerNav,
    },
    data() {
        return {
			userName:'',
			content:'',
			mobile:''
			
		};
    },
	methods:{
		commitData(){
			if(this.mobile == null || this.mobile==''){
				alert('您未填写联系电话');
				return;
			}
			if(this.userName == null || this.userName==''){
				alert('您未填写联系姓名');
				return;
			}
			if(this.content == null || this.content==''){
				alert('请填写您的简单需求');
				return;
			}
			this.$http.get(this.$api.url +'/papi/cooperation/add',
			   {params:{mobile:this.mobile,'content':this.content,'userName':this.userName}}).then((response) => {
			   alert('提交成功，后续工作人员会联系你');
			   this.mobile='';
			   this.userName='';
			   this.content='';
			   return;
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
	}
};
</script>
<style lang="less" scoped>
    // 公共
    .navtab {
        width: 1280px;
        margin: 0 auto;
    }
    .color {
        color: #2961EF !important;
    }
    .ignore {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    // 搜索
    .nav {
        background: #f7f8fa;
        width: 100%;
        height: 177px;
        .top {
            display: block;
            font-size: 16px;
            color: #777777;
            padding: 19px 0 24px;
            .infor {
                color: #2961EF;
            }
        }
        .newbox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .newtop {
                font-size: 26px;
                color: #000000;
                margin-bottom: 5px;
            }
            .newbot {
                font-size: 16px;
                color: #888888;
            }
            .input {
                width: 497px;
                height: 59px;
                background: #ffffff;
                box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
                border-radius: 30px;
                position: relative;
                input {
                    border: none;
                    position: absolute;
                    left: 30px;
                    top: 0;
                    height: 59px;
                    line-height: 59px;
                    width: 365px;
                    font-size: 16px;
                    color: #777777;
                }
                .select {
                    position: absolute;
                    right: 12px;
                    top: 8px;
                    width: 74px;
                    height: 43px;
                    line-height: 43px;
                    background: #2961EF;
                    border-radius: 30px;
                    font-size: 16px;
                    color: #ffffff;
                    text-align: center;
                }
            }
        }
    }
    .relation {
        margin-bottom: 70px;
        p {
            text-align: center;
            font-size: 30px;
            color: #333333;
            margin: 50px auto 40px;
        }
        .know {
            font-size: 16px;
            color: #777777;
            margin-bottom: 35px;
            span {
                color: #2961EF;
                height: 50px;
                display: inline-block;
                width: 7%;
                vertical-align: top;
            }
            div {
                width: 93%;
                display: inline-block;
            }
        }
        .message {
            padding: 30px 47px;
            background: #f7f8fa;
            .name {
                font-size: 16px;
                color: #333333;
            }
            input {
                background: #ffffff;
                border: none;
                width: 100%;
                margin: 20px 0;
            }
            .input {
                height: 45px;
            }
            .input1 {
                height: 178px;
            }
            .submit {
                width: 234px;
                height: 45px;
                line-height: 45px;
                text-align: center;
                background: #2961EF;
                border-radius: 23px 23px 23px 23px;
                font-size: 20px;
                color: #ffffff;
                margin: 0 auto;
                margin-top: 20px;
            }
        }
    }
    
</style>